const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let loadPromise = null;

const loadRecaptcha = () => {
  if (!SITE_KEY) return Promise.resolve(null);
  if (window.grecaptcha) return Promise.resolve(window.grecaptcha);
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(SITE_KEY)}`;
    script.async = true;
    script.onload = () => resolve(window.grecaptcha);
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return loadPromise;
};

// Returns a fresh v3 token for the given action, or null if reCAPTCHA is not configured/available
export const getRecaptchaToken = async (action) => {
  if (!SITE_KEY) return null;
  try {
    const grecaptcha = await loadRecaptcha();
    if (!grecaptcha) return null;
    return await new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(SITE_KEY, { action }).then(resolve).catch(reject);
      });
    });
  } catch {
    return null;
  }
};

export const isRecaptchaEnabled = () => Boolean(SITE_KEY);
